"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var gatsby_link_4 = require("gatsby-link");
function withPrefix(path) {
    return gatsby_link_4.withPrefix(path);
}
exports.withPrefix = withPrefix;
function withoutPrefix(path) {
    if (typeof __PREFIX_PATHS__ !== "undefined" && __PREFIX_PATHS__) {
        return path.replace(__PATH_PREFIX__, "");
    }
    return path;
}
exports.withoutPrefix = withoutPrefix;
function getPrefixedSrcSet(srcSet) {
    return srcSet.split(",\n").map(function (imgSrc) {
        return withPrefix(imgSrc);
    }).join(",\n");
}
exports.getPrefixedSrcSet = getPrefixedSrcSet;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/gatsby-utils.ts